import { Spin } from 'antd';
import React from 'react';
import './style.scss';
type IndexType = { content?: string };
export const FullSLoader: React.FC<IndexType> = ({ content }) => {
  return (
    <div className="full-screen-loader">
      <Spin tip={content || 'Loading please wait...'} />
    </div>
  );
};
